import type { PropsWithChildren } from "react";
import { useSession } from "../auth/sessionContext";
import { InlineNotice } from "../components/Feedback/InlineNotice";
import { hasCustomWorkflowsAccess } from "./workflowAccess";
import styles from "./WorkflowsPage.module.css";

export function WorkflowRouteGuard({ children }: PropsWithChildren) {
  const session = useSession();
  if (!hasCustomWorkflowsAccess(session)) {
    return (
      <section className={styles.denied} data-status-code="403" aria-label="Workflows unavailable">
        <InlineNotice tone="error" title="403 — Workflows unavailable">
          Custom Workflows are not enabled for this workspace.
        </InlineNotice>
      </section>
    );
  }
  return children;
}
